import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { UPDATE_CURRENT_SESSION_TEST_DATA } from "../../../../../store/actions";
import { Context } from "../../../../../store/store";
import { PUBLIC_TEST_URL } from "../../../constants";
import { useAttrsSessionId } from "../../hooks/useAttrsSessionId";
import { buildUrlWithGetParams, canStartTest } from "../../utils";
import Button from "./../../components/button";
import "./styles.scss";

function Test() {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const {
    publicTest: { _id, welcomeHtml, startButton, sets, entries },
    testSessionData: { sessionId },
  } = state;
  const attrsSessionId = useAttrsSessionId();

  const onStartButtonClick = () => {
    if (
      !(
        (entries && entries.length && entries[0].sessionId === sessionId) // check if we have entries with same session ID, then continue
      )
    ) {
      const newSessionId = attrsSessionId ?? uuidv4();
      dispatch({
        type: UPDATE_CURRENT_SESSION_TEST_DATA,
        payload: { sessionId: newSessionId },
      });
    }

    navigate(buildUrlWithGetParams(`${PUBLIC_TEST_URL}/${_id}/${sets[0]._id}`));
  };

  return (
    <div className="tg_page tg_test-info">
      <div
        className="tg_test-welcome-html"
        dangerouslySetInnerHTML={{
          __html: welcomeHtml,
        }}
      />
      <div className="tg_column">
        <Button
          large
          onClick={onStartButtonClick}
          disabled={!canStartTest(state.publicTest)}
        >
          {startButton}
        </Button>
      </div>
    </div>
  );
}

export default Test;
